<template>
	<v-layout row justify-center>
		<v-dialog
			v-model="dialog"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<template v-slot:activator="{ on }">
				<v-btn color="primary" outline v-on="on">
					<i class="material-icons">add</i>
					{{ $t("message.reorder") }}
				</v-btn>
			</template>
			<v-card>
				<v-toolbar dark color="#262261">
					<v-btn icon dark @click="dialog = false">
						<v-icon>close</v-icon>
					</v-btn>
					<v-toolbar-title>{{ $t("message.reorder") }}</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-toolbar-items>
						<v-btn dark flat @click="dialog = false">{{
							$t("message.save")
						}}</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<p class="dnd-notice">{{ $t("message.dndNotice") }}</p>
				<draggable :list="catalogues" class="list-group" ghost-class="ghost">
					<div
						class="list-item"
						v-for="element in catalogues"
						:key="element.name"
					>
						{{ element.name }}
					</div>
				</draggable>
				<v-divider></v-divider>
			</v-card>
		</v-dialog>
	</v-layout>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from "vuedraggable";
export default {
	components: {
		draggable,
	},
	data() {
		return {
			dialog: false,
			catalogues: [],
		};
	},
	updated() {
		console.log(this.catalogues);
	},
	watch: {
		dialog: function(show) {
			if (show) {
				this.getCatalogues();
			}
		},
	},
	methods: {
		getCatalogues() {
			console.log(
				this.$store.getters.catalogues.filter((c) => c.available == 1)
			);
			this.catalogues = this.$store.getters.catalogues.filter(
				(c) => c.available == 1
			);
		},
	},
};
</script>

<style scoped>
.list-item {
	padding: 5px;
}
.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}
.dnd-notice {
	text-align: center;
	margin: 10px 0;
}
</style>
